export const toPrice = (cents: number, options?: { withCurrencySymbol?: boolean; onlyFullEuros?: boolean }) => {
    const { withCurrencySymbol = true, onlyFullEuros = false } = options || {};
    const fullEuros = onlyFullEuros ? Math.ceil(cents / 100) : cents / 100;
    return new Intl.NumberFormat('nl-NL', {
        style: withCurrencySymbol ? 'currency' : undefined,
        currency: withCurrencySymbol ? 'EUR' : undefined,
        minimumFractionDigits: onlyFullEuros ? 0 : 2,
    }).format(fullEuros);
};

export const toPriceRounded = (cents: number) => {
    return toPrice(cents, {
        withCurrencySymbol: true,
        onlyFullEuros: true,
    })
};

export const toPercentage = (n: number, decimals = 2) => {
    return (
        Number(Math.round(n * Math.pow(10, decimals)) / Math.pow(10, decimals)).toLocaleString('nl-NL', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }) + '%'
    );
};

export function reverseFormatNumber(val: string, locale: string): number {
    const group = new Intl.NumberFormat(locale).format(1111).replace(/1/g, '');
    const decimal = new Intl.NumberFormat(locale).format(1.1).replace(/1/g, '');
    let reversedVal = val.replace(new RegExp('\\' + group, 'g'), '');
    reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');
    return Number.isNaN(reversedVal) ? 0 : +reversedVal;
}
